import React from "react";
import { Avatar, Box, Typography } from "@mui/material";

const sections = [
  {
    key: "lpg",
    label: "שירות גז",
    icon: "gas-tank.svg",
  },
  {
    key: "power",
    label: "שירות חשמל",
    icon: "electricity.svg",
  },
] as const;

type SectionKey = (typeof sections)[number]["key"];

export default function SectionSelector({
  activeSection,
  onSectionClick,
}: {
  activeSection: SectionKey | null;
  onSectionClick: (section: SectionKey) => void;
}) {
  return (
    <div className="row" style={{ textAlign: "center", marginBottom: 10 }}>
      <Typography
        variant="h5"
        sx={{ mb: 5, color: "primary.main", letterSpacing: 1 }}
      >
        <strong style={{ fontWeight: 900, color: "black" }}>
          ברוכים הבאים 💚
        </strong>
        <br />
        פשוט בוחרים בתחום השירות הרצוי 👇🏿 ומתחילים!
        <br />
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          // mt: 1,
        }}
      >
        {sections.map(({ key, label, icon }) => {
          const isActive = activeSection === key;
          return (
            <Box
              key={key}
              onClick={() => onSectionClick(key)}
              sx={{
                display: "flex",
                flexDirection: "row-reverse", // RTL – label right, icon left
                alignItems: "center",
                justifyContent: "space-between",
                width: 230,
                bgcolor: isActive ? "#f6f6f6" : "#f6f6f6",
                borderRadius: 4,
                px: 3,
                py: 2,
                cursor: "pointer",
                boxShadow: 2,
                border: "2px solid #01F156",

                transition: "all 0.2s ease-in-out",
              }}
            >
              <Typography
                variant="h5"
                fontWeight={isActive ? 800 : 700}
                color={isActive ? "primary" : "text.primary"}
                textAlign="right"
              >
                {label}
              </Typography>

              <Avatar
                sx={{
                  bgcolor: isActive ? "primary.main" : "grey.100",
                  width: 56,
                  height: 56,
                }}
              >
                <img
                  src={`svg/${icon}`}
                  alt=""
                  style={{
                    width: "1.8em",
                    height: "1.8em",
                  }}
                />
              </Avatar>
            </Box>
          );
        })}

      </Box>{" "}
    </div>
  );
}
